module.exports = __webpack_public_path__ + "static/media/comic-move-05.29beb205.png";